(function ($) {
  Drupal.behaviors.sdSppFormatterv1 = {
    attach: function (context) {
      var $productFull = $('.sd-product-spp__product-full', context);

      window.onload = function () {
        // came from initial SPP template, check if this can be removed, we should not have
        // js functions specific to brands, if posible
        $productFull.removeClass('full-view-height');
      };
    }
  };
})(jQuery);
